<script setup lang="ts">
import PrimeButton from 'primevue/button';

const runtimeConfig = useRuntimeConfig();

const title = 'Solutions For Contractors - Vismo';
const description = 'Keep the Site Moving: Access, Update, and Deliver Files Without the Fuss';

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: joinPath(runtimeConfig.public.siteUrl, 'og.png'),
  ogUrl: joinPath(runtimeConfig.public.siteUrl, '/solutions/contractors'),
  twitterTitle: title,
  twitterDescription: description,
  twitterCard: 'summary_large_image',
  twitterImage: joinPath(runtimeConfig.public.siteUrl, 'twitter.png'),
});

// eslint-disable-next-line vue/max-len
const scheduleDemoLink = `mailto:${runtimeConfig.public.emailInfo}?subject=Schedule A Demo&body=Hi, I would love a demo!`;
</script>

<template>
  <div class="contractors">
    <section class="contractors__cta">
      <h2 class="contractors__cta-title">This Page Is Coming Soon...</h2>
      <p class="contractors__cta-subtitle">
        In the meantime, see how Vismo can save you time and money by checking out our other
        <NuxtLink to="/solutions">solutions</NuxtLink>.
      </p>
      <div class="contractors__cta-buttons">
        <NuxtLink :to="runtimeConfig.public.idUrl" external>
          <PrimeButton label="Try Vismo for Free" />
        </NuxtLink>
        <NuxtLink :to="scheduleDemoLink">
          <PrimeButton label="Schedule a Demo" outlined />
        </NuxtLink>
      </div>
    </section>
  </div>
</template>

<style scoped lang="scss">
@use '../../assets/styles/_globals.scss' as g;

.contractors {
  display: flex;
  flex-direction: column;
  gap: 5rem;
  overflow: hidden;

  &__cta {
    width: 100%;
    padding: 3rem 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    background: light-dark(var(--p-surface-0), var(--p-surface-900));
    margin-bottom: 3rem;

    @media (max-width: g.$desktop-breakpoint) {
      padding: 3rem 3rem;
    }

    @media (max-width: g.$mobile-breakpoint) {
      padding: 3rem 2rem;
    }
  }

  &__cta-title {
    font-size: 2rem;
    font-weight: 800;
    text-align: center;
  }

  &__cta-subtitle {
    font-size: 1.2rem;
    font-weight: 300;
    text-align: center;
    max-width: 40rem;
  }

  &__cta-buttons {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;

    @media (max-width: g.$mobile-breakpoint) {
      flex-direction: column;
      width: 100%;

      :deep(.p-button) {
        width: 100%;
      }
    }
  }
}
</style>
